import { QueryType } from '@sportybot-web/services/sporty-gateway/generated/graphql';
import { z } from 'zod';

export const searchParamsSchema = z.object({
  q: z.string().optional().default(''),
  qt: z.enum(QueryType).optional().default(QueryType.STRUCTURED),
});
